<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <div class="card">
          <div class="card-head">支付配置</div>
          <div class="card-body">
            <Alert type="warning">
              以下收款接口，极客商城仅提供API接入服务，收款平台的可靠性请自行斟酌！
              <template slot="desc">
                1.涉及到资金及信息安全，请勿使用盗版程序 <br />
                2.收款接口选用有相关执照的商家推荐使用官方接口 <br />
                3.如需定制其它收款接口，欢迎
                <a href="http://wpa.qq.com/msgrd?v=3&uin=3332342231&site=qq&menu=yes"
                  style="color: rgb(87, 163, 243)">与我QQ联系</a>
              </template>
            </Alert>
            <Tabs type="card" :animated="false">
              <TabPane label="基础配置">
                <Form :model="pay_type" :label-width="100" style="min-height: 250px">
                  <FormItem label="支付宝接口" :class="!$store.state.isMobile ? 'w50' : ''">
                    <Select placeholder="请选择渠道" v-model="pay_type.alipay_type">
                      <Option value="0">关闭</Option>
                      <Option value="1">支付宝企业支付</Option>
                      <Option value="2">码支付</Option>
                      <Option value="3">当面付</Option>
                      <Option value="4">易支付</Option>
                      <Option value="5">GeekPay（内置码支付）</Option>
                    </Select>
                  </FormItem>
                  <FormItem label="微信接口" :class="!$store.state.isMobile ? 'w50' : ''">
                    <Select placeholder="请选择渠道" v-model="pay_type.wxpay_type">
                      <Option value="0">关闭</Option>
                      <Option value="1">微信企业支付</Option>
                      <Option value="2">码支付</Option>
                      <Option value="4">易支付</Option>
                      <Option value="5">GeekPay（内置码支付）</Option>
                    </Select>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="Save(pay_type)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>

              <!-- 微信企业支付 -->
              <TabPane label="微信企业支付">
                <Alert>
                  微信企业支付：官方接口，商家可申请，有年费，申请较为复杂
                  <template slot="desc">
                    由于微信接口限制，JSAPI支付需开启公众号登录功能，并且请确认在微信APP内能正常使用公众号登录
                  </template>
                </Alert>
                <Form :model="pay_key" :label-width="120">
                  <FormItem label="微信APPID">
                    <Input v-model="pay_key.wx_appid" placeholder="微信支付APPID"></Input>
                  </FormItem>
                  <FormItem label="商户号">
                    <Input v-model="pay_key.wx_mchid" placeholder="微信支付MCHID/商户号"></Input>
                  </FormItem>
                  <FormItem label="微信KEY">
                    <Input v-model="pay_key.wx_key" placeholder="微信支付KEY"></Input>
                  </FormItem>
                  <FormItem label="微信APPSECRET" v-if="pay_key.wx_jsapi == 1">
                    <Input v-model="pay_key.wx_appsecret" placeholder="微信支付APPSECRET"></Input>
                  </FormItem>
                  <FormItem label="H5支付">
                    <i-switch v-model="pay_key.wx_h5" :true-value="'1'" :false-value="'0'" />
                    <p style="font-size: 12px; color: #999">
                      * 移动端跳转到微信APP支付(需开通 H5支付)
                    </p>
                  </FormItem>
                  <FormItem label="JSAPI支付">
                    <i-switch v-model="pay_key.wx_jsapi" :true-value="'1'" :false-value="'0'" />
                    <p style="font-size: 12px; color: #999">
                      * 微信APP内直接发起支付
                    </p>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="Save(pay_key)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>

              <!-- 支付宝企业支付 -->
              <TabPane label="支付宝企业支付">
                <Alert>
                  支付宝即时到账支付：需提交营业执照及备案域名申请，申请难度高
                  <template slot="desc">
                    需提交资料开通支付宝手机网站支付与电脑网站支付产品
                  </template>
                </Alert>
                <Form :model="pay_key" :label-width="120">
                  <FormItem label="合作身份者ID">
                    <Input v-model="pay_key.alipay_partner" placeholder="合作身份者ID"></Input>
                    <p style="font-size: 12px; color: #999">
                      *
                      合作身份者ID，签约账号，以2088开头由16位纯数字组成的字符串，查看地址：https://b.alipay.com/order/pidAndKey.htm
                    </p>
                  </FormItem>
                  <FormItem label="安全校验码">
                    <Input v-model="pay_key.alipay_key" placeholder="安全校验码"></Input>
                    <p style="font-size: 12px; color: #999">
                      *
                      MD5密钥，安全检验码，由数字和字母组成的32位字符串，查看地址：https://b.alipay.com/order/pidAndKey.htm
                    </p>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(pay_key)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>

              <!-- GeekPay -->
              <TabPane label="GeekPay">
                <Alert>
                  Geek-Shop内置个人收款码支付<br />
                  无需对接第三方平台，资金实时到账<br />
                  开启后上传自己的微信支付宝收款码即可收款
                  <template slot="desc">
                    需要有一定的码支付使用经验，官方可提供付费技术支持<br>
                    详细配置教程可查看：<a href="https://www.kancloud.cn/osuu234/geek-shop/2558717" target="_blank">使用手册</a>
                  </template>
                </Alert>

                <Button @click="$router.push('/geekPay/qrcode')" style="margin-right:5px" type="info">收款码管理</Button>
                <Button @click="goDown" type="primary" style="margin-right:5px">下载监控端</Button>
                <Button @click="_getQrcode" type="success" :loading="loading">扫码绑定</Button>
                <Form :model="geek_pay" :label-width="100" style="margin-top:20px">
                  <FormItem label="最后心跳">
                    <Input v-model="geek_pay.lastheart" disabled>
                    </Input>
                  </FormItem>
                  <FormItem label="API密钥">
                    <Input v-model="geek_pay.geek_key" :disabled="disabled == 'geek_key'?false:true">
                    <Button slot="append" @click="disabled = 'geek_key'">自定义</Button>
                    </Input>
                  </FormItem>
                  <FormItem label="最大并发">
                    <Input v-model="geek_pay.merge" type="number" :disabled="disabled == 'merge'?false:true">
                    <Button slot="append" @click="disabled = 'merge'">自定义</Button>
                    </Input>
                  </FormItem>
                  <FormItem label="区分方式">
                    <RadioGroup v-model="geek_pay.mode_range">
                      <Radio label="1">金额递增</Radio>
                      <Radio label="2">金额递减</Radio>
                    </RadioGroup>
                  </FormItem>
                  <FormItem label="订单超时时间">
                    <Input v-model="geek_pay.time_out" type="number" placeholder="订单超时时间，单位/秒"></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(geek_pay)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>

              <!-- 当面付 -->
              <TabPane label="当面付">
                <Alert>
                  支付宝当面付：个人可申请，申请难度低
                  <template slot="desc">
                    支持PC端扫码支付<br />
                    支持移动端H5支付</template>
                </Alert>
                <Form :model="pay_key" :label-width="100">
                  <FormItem label="APPID">
                    <Input v-model="pay_key.f2fpay_appid" placeholder="应用ID APPID"></Input>
                  </FormItem>
                  <FormItem label="支付宝公钥">
                    <Input v-model="pay_key.f2fpay_public_key" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"
                      placeholder="支付宝公钥"></Input>
                  </FormItem>
                  <FormItem label="商户私钥">
                    <Input v-model="pay_key.f2fpay_private_key" type="textarea" :autosize="{ minRows: 2, maxRows: 5 }"
                      placeholder="商户私钥"></Input>
                  </FormItem>
                  <FormItem>
                    <Button type="primary" @click="Save(pay_key)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>

              <!-- 易支付 -->
              <TabPane label="易支付">
                <Alert> 本程序只负责技术接入，平台可靠性请自行斟酌 </Alert>

                <Form :model="pay_key" :label-width="100">
                  <FormItem label="商户ID">
                    <Input v-model="pay_key.epay_id" placeholder="商户ID"></Input>
                  </FormItem>
                  <FormItem label="商户密钥">
                    <Input v-model="pay_key.epay_key" placeholder="商户密钥"></Input>
                  </FormItem>
                  <FormItem label="接口地址">
                    <Input v-model="pay_key.epay_api" placeholder="接口地址"></Input>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(pay_key)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
              <TabPane label="码支付">
                <Alert>
                  码支付支持微信、支付宝收款，个人可申请<br />
                  微蓝码支付请用易支付接口配置

                  <template slot="desc">
                    码支付地址：<a href="https://codepay.mzf667.cn" target="_blank" style="color: rgb(87, 163, 243)">立即前往</a>
                  </template>
                </Alert>

                <Form :model="pay_key" :label-width="100">
                  <FormItem label="码支付ID">
                    <Input v-model="pay_key.codepay_id" placeholder="码支付ID"></Input>
                  </FormItem>
                  <FormItem label="通信密钥">
                    <Input v-model="pay_key.codepay_key" placeholder="通信密钥"></Input>
                  </FormItem>
                  <FormItem label="网关地址">
                    <Input v-model="pay_key.codepay_gateway" placeholder="码支付网关地址"></Input>
                    <p style="font-size: 12px; color: #999">* 默认无需修改</p>
                  </FormItem>

                  <FormItem>
                    <Button type="primary" @click="Save(pay_key)" :loading="creating">保存</Button>
                  </FormItem>
                </Form>
              </TabPane>
            </Tabs>
          </div>
        </div>
      </div>
      <Modal mask sticky reset-drag-position v-model="modal" :width="300" footer-hide
        title="配置码">
        <img :src="qr_img" alt="">
         <Alert class="text" type="success">下载GeekPay监控端软件，点击绑定网站，扫描此二维码即可绑定</Alert>
       
      </Modal>
    </div>
  </div>
</template>

<script>
  import {
    getSystem,
    putSystem,getQrcode
  } from "@/api/admin";
  export default {
    data() {
      return {
        pay_type: {},
        pay_key: {},
        geek_pay: {},
        creating: false,
        disabled: true,
        qr_img:"",
        modal:false,
        loading:false
      };
    },
    created() {
      this._getData();
    },

    methods: {
      // 获取列表
      _getData() {
        getSystem("pay_type").then((res) => {
          this.pay_type = res.data;
        });
        getSystem("pay_key").then((res) => {
          this.pay_key = res.data;
        });
        getSystem("geek_pay").then((res) => {
          this.geek_pay = res.data;
        });
      },
      // 基础配置
      Save(arr) {
        this.creating = true;
        putSystem({
          createData: arr,
        }).then((res) => {
          if (res.code == 200) {
            this.$Message.success({
              background: true,
              content: res.msg,
            });
            this._getData();
          } else {
            this.$Message.error({
              background: true,
              content: res.msg,
            });
          }
          this.creating = false;
        });
      },
      // 配置二维码
      _getQrcode(){
        this.loading = true
        getQrcode().then((res) => {
          this.qr_img = res.data;
          this.modal = true
          this.loading = false
        });
      },
      goDown(){
        window.open("https://osuu.lanzouw.com/s/geekpay")
      }
    },
  };
</script>

<style lang="less" scoped>
  .ivu-tabs {
    min-height: 320px!important;
  }

  .w50 {
    width: 50%;
  }
  .text{
    margin: 0 10px;
  }
  /deep/.ivu-alert{
    padding-right: 16px;
  }
  a{
    color: blue;
  }
</style>